import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        fetch({commit, dispatch}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return new Promise((resolve) => {
                axios.get(
                    '/api/mixins/users/logs',
                    { params: filter}
                ).then(({data}) => {
                    resolve(data)
                }).finally(() => {
                    commit('TOGGLE_PRELOADER', false, {root: true})
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
    }
}
